import { isOagfAdmin } from "core/helpers";
import { MdaPaymentReports } from "./MdaPaymentReport";
import OagfPaymentReports from "./OagfPaymentReport";

const PaymentReports = () => {
  return <>{isOagfAdmin() ? <OagfPaymentReports /> : <MdaPaymentReports />}</>;
};

export { PaymentReports };
